//bloodAnalyseisService.je
import { getFunctions, httpsCallable } from 'firebase/functions';
import { db } from '../firebase';
import { doc, deleteDoc } from 'firebase/firestore';

const functions = getFunctions(undefined, 'europe-west1');

export const bloodAnalysisService = {
  /**
   * Récupère l'historique des analyses (déchiffrées côté backend)
   */
  async getAnalyses(userId) {
    try {
      if (!userId) {
        console.warn('⚠️ Utilisateur non connecté');
        return [];
      }

      const getBloodAnalysesFn = httpsCallable(functions, 'getBloodAnalyses');
      const result = await getBloodAnalysesFn();

      return result.data.analyses;
    } catch (error) {
      console.error('❌ Erreur récupération analyses:', error);
      return [];
    }
  },

  /**
   * Supprime une analyse
   */
  async deleteAnalysis(analysisId, userId) {
    try {
      if (!userId) {
        console.warn('⚠️ Impossible de supprimer');
        return false;
      }

      await deleteDoc(doc(db, 'bloodAnalyses', analysisId));
      return true;
    } catch (error) {
      console.error('❌ Erreur suppression analyse:', error);
      return false;
    }
  },

  /**
   * Supprime TOUTES les analyses d'un utilisateur
   */
  async clearAllAnalyses(userId) {
    try {
      if (!userId) return 0;

      const analyses = await this.getAnalyses(userId);
      const deletePromises = analyses.map((a) => deleteDoc(doc(db, 'bloodAnalyses', a.id)));
      await Promise.all(deletePromises);

      return analyses.length;
    } catch (error) {
      console.error('❌ Erreur suppression complète:', error);
      throw error;
    }
  },
};
